import { Component } from '@angular/core';
import { PageHeroComponent } from "../../../../shared/components/page-hero/page-hero.component";

@Component({
  selector: 'app-projects-hero',
  imports: [PageHeroComponent],
  templateUrl: './projects-hero.component.html',
  styleUrl: './projects-hero.component.css',
})
export class ProjectsHeroComponent {

}
